import { createClient } from "@supabase/supabase-js";
import { invoke } from "./tauri-web";
import { isTauri } from "./web-runtime";

// Same Oriora Supabase project as the rest of the ecosystem. Anon key is public (safe to embed).
const SUPABASE_URL = "https://qawkzqlwaiqhlxroevsa.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFhd2t6cWx3YWlxaGx4cm9ldnNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5MTYwMDYsImV4cCI6MjA5MzQ5MjAwNn0.GJ7peohJ7YsJvUwuZhZushFneL6lJAu8lf9Iv-5g-xc";

// Tauri filesystem-backed Supabase session storage — persists in the app data dir
// (auth/), surviving WebView storage clears + app rebuilds. Mirrors expense_audit_ai.
const tauriAuthStorage = {
  async getItem(key: string): Promise<string | null> {
    try {
      return (await invoke<string | null>("auth_storage_get", { key })) ?? null;
    } catch {
      return null;
    }
  },
  async setItem(key: string, value: string): Promise<void> {
    try {
      await invoke<void>("auth_storage_set", { key, value });
    } catch (e) {
      console.error("auth storage set failed", e);
    }
  },
  async removeItem(key: string): Promise<void> {
    try {
      await invoke<void>("auth_storage_remove", { key });
    } catch (e) {
      console.error("auth storage remove failed", e);
    }
  },
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: isTauri() ? tauriAuthStorage : undefined, // native: app-dir fs; web: supabase default (localStorage)
  },
});

// Mirror the access token from auth-state changes. On a cold Tauri/iOS launch, getSession()
// has proven unreliable — it can return null even after onAuthStateChange delivered the restored
// session (async filesystem storage). Keep the token here as a fallback the brain call can reach.
let cachedAccessToken: string | null = null;
supabase.auth.onAuthStateChange((_event, session) => {
  cachedAccessToken = session?.access_token ?? null;
});

export async function getAccessToken(): Promise<string | null> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) return session.access_token;
  } catch {
    /* fall through to the cached token */
  }
  return cachedAccessToken;
}
